import React, { useState, useEffect } from 'react';
import Lodash from 'lodash';
import { useHistory } from 'react-router-dom';
import { makeStyles } from '@material-ui/core/styles';
import { useJwt } from 'react-jwt';

import DeleteSharpIcon from '@material-ui/icons/DeleteSharp';
import EditIcon from '@material-ui/icons/Edit';
import CircularProgress from '@material-ui/core/CircularProgress';
import SwapHorizIcon from '@material-ui/icons/SwapHoriz';

import { tableHeaders } from './data';
import MacroList from '../MacroList/MacroList';
import Filters from '../../Components/Filters/RegistrosElectFilter';
import PLNDialog from '../../Components/PLNDialog/PLNDialog';

import Storage from '../../Storage/Storage';
import fiscalesMesaApi from '../../Core/Api/fiscalesMesaApi';
import { useFiscalesMesaAvailable } from '../../Core/Api/periodoApi';

const useStyles = makeStyles(() => ({
  btnAdd: {
    float: 'right',
    width: 150,
    height: 30,
    marginTop: 5,
  },
  btnPrint: {
    float: 'right',
    width: 150,
    height: 30,
    marginTop: 5,
    marginLeft: 15,
  },
  container: {
    paddingTop: 40,
    paddingBottom: 40,
  },
  paper: {
    padding: 20,
    display: 'flex',
    overflow: 'auto',
    flexDirection: 'column',
  },
  actionContainer: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
  },
}));

const FiscalesMesa = () => {
  const classes = useStyles();
  const history = useHistory();
  const tokenStorage = Storage.instance;
  // const filteredItems = [];

  // Se valida si esta habilitada la opcion (Agregar Fiscales Mesa)
  const isFiscalesMesaAvailable =
    useFiscalesMesaAvailable(22);
  const fiscalesMesaAvailable = Lodash.get(
    isFiscalesMesaAvailable,
    ['data', 'response'],
    null,
  );

  // Se valida si esta habilitada la opcion (Editar Fiscales Mesa)
  const isEditarFiscalesMesaAvailable =
    useFiscalesMesaAvailable(23);
  const editarFiscalesMesaAvailable = Lodash.get(
    isEditarFiscalesMesaAvailable,
    ['data', 'response'],
    null,
  );    

  // Se valida si esta habilitada la opcion (Eliminar Fiscales Mesa)
  const isEliminarFiscalesMesaAvailable =
    useFiscalesMesaAvailable(24);
  const eliminarFiscalesMesaAvailable = Lodash.get(
    isEliminarFiscalesMesaAvailable,
    ['data', 'response'],
    null,
  );

  // Se valida si esta habilitada la opcion (Sustituir Fiscales Mesa)
  const isSustituirFiscalesMesaAvailable =
    useFiscalesMesaAvailable(46);
  const sustituirFiscalesMesaAvailable = Lodash.get(
    isSustituirFiscalesMesaAvailable,
    ['data', 'response'],
    null,
  );

  const { decodedToken } = useJwt(tokenStorage.getToken());

  const [items, setItems] = useState([]);
  const [page, setPage] = useState(1);
  const [filteredItems, setFilteredItems] = useState([]); // used for filtering
  // eslint-disable-next-line no-unused-vars
  const [isBeingFiltered, setIsBeingFiltered] = useState(
    false,
  );
  const [isDataEmpty, setDataEmpty] = useState(true);
  const [filters, setFilters] = useState({
    provincia: '',
    canton: '',
    distrito: '',
    cedula: '',
    primerApellido: '',
    segundoApellido: '',
    nombre: '',
  });
  const [open, setOpenDialog] = React.useState(false);
  const [dataRemove, setDataRemove] = React.useState(null);
  const [isRemoved, setIsRemoved] = useState(false); // used on remove modal
  const [removedMsj, setRemoveMsj] = useState(
    'El registro se eliminará permanentemente. ¿Desea proceder?',
  );
  const [hiddenBtn, setHiddenBtn] = useState(false);

  const getFilterKeys = Object.getOwnPropertyNames(filters);
  const TIMING_ON_SEARCH = 900;

  /**
   * Filter Items
   */
  const applyFilters = async () => {
    const activeFilters = getFilterKeys.filter(
      filter => filters[filter] !== '',
    );

    setDataEmpty(true);

    if (activeFilters.length > 0) {
      // FITLRO FUNCIONAL CON UN INPUT: nombre (DO NOT REMOVED YET)
      /* const result = filteredItems.filter(_item => {
        let currentFilter = _item.nombre;
        if (typeof currentFilter === 'number')
          currentFilter = currentFilter.toString();

        return currentFilter
          .toLowerCase()
          .includes(filters.nombre.toLowerCase());
      });

      setDataEmpty(!result.length > 0);

      if (result.length > 0) setFilteredItems(result); */

      const dataFiltered = activeFilters.map(myFilter => {
        const result = items.filter(_item => {
          let currentFilter = _item[myFilter];
          if (typeof currentFilter === 'number')
            currentFilter = currentFilter.toString();

          return currentFilter
            .toLowerCase()
            .includes(filters[myFilter].toLowerCase());
        });

        setDataEmpty(!result.length > 0);
        if (result.length > 0) setFilteredItems(result);
        // console.log(result);
        return result;
      });

      console.log(dataFiltered);
    } else {
      setFilteredItems(items);
      setDataEmpty(false);
    }
  };

  /**
   * Get Members when the page loads
   */
  const getAllMembers = async () => {
    let itemsList = [];

    setDataEmpty(false);

    try {
      if (decodedToken) {
        const info = await fiscalesMesaApi.getAllFiscalesMesa(
          decodedToken.num_cedula,
        );

        const data = info.data.response;

        if (data instanceof Array && info.status === 200) {
          itemsList = data.map(member => {
            return {
              provincia: member.des_nombre_p,
              canton: member.des_nombre_c,
              distrito: member.des_nombre_d,
              jrv: member.cod_mesa,
              puesto: member.des_puesto,
              cedula: member.num_cedula,
              primerApellido: member.des_apell1,
              segundoApellido: member.des_apell2,
              nombre: member.des_nombre,
              id: member.num_linea,
            };
          });
        }
      }
    } catch (error) {
      console.warn(error);
    }

    setDataEmpty(itemsList.length === 0);
    setItems(itemsList);
    setFilteredItems(itemsList);
  };

  /**
   * Remove a member selected by user
   */
  const removeMemberByNum = async () => {
    const numLinea = dataRemove.id;

    if (numLinea && numLinea > 0) {
      setIsRemoved(true);

      await fiscalesMesaApi
        .deleteFiscal(numLinea)
        .then(_response => {
          const info = _response.data.response;

          if (info === 1 && _response.status === 200) {
            setIsRemoved(false);
            setHiddenBtn(true);
            setRemoveMsj(
              'Fiscal de Mesa eliminado correctamente.',
            );
            setTimeout(() => {
              setOpenDialog(false);
              window.location.href = '/fiscales-mesa/';
            }, 3000);
          } else {
            setHiddenBtn(false);
            setRemoveMsj(
              'La operación no se pudo completar. Intente de nuevo.',
            );
          }
        });
    }
  };

  useEffect(() => {
    async function fetchListAPI() {
      await getAllMembers();
    }

    fetchListAPI();
  }, [decodedToken]);

  useEffect(() => {
    async function proceedFilters() {
      await applyFilters();
    }

    const timeoutId = setTimeout(() => {
      if (filteredItems.length > 0) proceedFilters();
    }, TIMING_ON_SEARCH);
    return () => clearTimeout(timeoutId);
  }, [filters]);

  /**
   * List all filters required on the page list
   */
  const listFilters = () => {
    return [
      {
        label: 'Provincia:',
        action: async ev => {
          const updatedValue = {
            provincia: ev.currentTarget.value,
          };
          await setFilters({
            ...filters,
            ...updatedValue,
          });
        },
        value: filters.provincia,
        inputId: 'filter-provincia',
        responsiveSize: {
          xs: 6,
          sm: 3,
        },
      },
      {
        label: 'Cantón:',
        action: async ev => {
          const updatedValue = {
            canton: ev.currentTarget.value,
          };
          await setFilters({
            ...filters,
            ...updatedValue,
          });
        },
        value: filters.canton,
        inputId: 'filter-canton',
        responsiveSize: {
          xs: 6,
          sm: 3,
        },
      },
      {
        label: 'Distrito:',
        action: async ev => {
          const updatedValue = {
            distrito: ev.currentTarget.value,
          };
          await setFilters({
            ...filters,
            ...updatedValue,
          });
        },
        value: filters.distrito,
        inputId: 'filter-distrito',
        responsiveSize: {
          xs: 6,
          sm: 3,
        },
      },
      {
        label: '# Cédula:',
        action: async ev => {
          const updatedValue = {
            cedula: ev.currentTarget.value,
          };

          await setFilters({
            ...filters,
            ...updatedValue,
          });
        },
        value: filters.cedula,
        inputId: 'filter-cedula',
        responsiveSize: {
          xs: 6,
          sm: 3,
        },
      },
      {
        label: '1er Apellido:',
        action: async ev => {
          const updatedValue = {
            primerApellido: ev.currentTarget.value,
          };
          await setFilters({
            ...filters,
            ...updatedValue,
          });
        },
        value: filters.primerApellido,
        inputId: 'filter-first',
        responsiveSize: {
          xs: 6,
          sm: 3,
        },
      },
      {
        label: '2do Apellido:',
        action: async ev => {
          const updatedValue = {
            segundoApellido: ev.currentTarget.value,
          };
          await setFilters({
            ...filters,
            ...updatedValue,
          });
        },
        value: filters.segundoApellido,
        inputId: 'filter-last',
        responsiveSize: {
          xs: 12,
          sm: 3,
        },
      },
      {
        label: 'Nombre:',
        action: async ev => {
          const updatedValue = {
            nombre: ev.currentTarget.value,
          };
          await setFilters({
            ...filters,
            ...updatedValue,
          });
        },
        value: filters.nombre,
        inputId: 'filter-name',
        responsiveSize: {
          xs: 12,
          sm: 3,
        },
      },
    ];
  };

  /**
   * List all actions that a user can do for each item in the list
   */
  const setActions = () => {
    const actions = [];

    const actionEdit = {
      aria: 'Editar Fiscal de Mesa',
      key: 'edit',
      showAction: editarFiscalesMesaAvailable ? true : false,
      icon: (
        <EditIcon
          fontSize="inherit"
          style={{ color: '#84BF48' }}
        />
      ),
      clickHandler: _item => {
        window.location.href = `/fiscales-mesa/edit/${_item.id}`;
      },
    };

    actions.push(actionEdit);

    const actionRemove = {
      aria: 'Eliminar Fiscal de Mesa',
      key: 'remove',
      showAction: eliminarFiscalesMesaAvailable ? true : false,
      icon: (
        <DeleteSharpIcon
          fontSize="inherit"
          style={{ color: '#cc0000' }}
        />
      ),
      clickHandler: _item => {
        setDataRemove(_item);
        setOpenDialog(true);
      },
    };

    actions.push(actionRemove);

    const actionSwitch = {
      aria: 'Sustituir Fiscal de Mesa',
      key: 'switch',
      showAction: sustituirFiscalesMesaAvailable ? true : false,
      icon: (
        <SwapHorizIcon
          fontSize="30"
          style={{ color: '#00ab9c' }}
        />
      ),
      clickHandler: _item => {
        window.location.href = `/fiscales-mesa/switch/${_item.id}`;
      },
    };

    actions.push(actionSwitch);
    return actions;
  };

  const pageHandler = async (ev, value) => {
    ev.preventDefault();
    setPage(value);
  };

  const handlePrint = () => {
    // Crear contenido para imprimir con los datos filtrados
    const printContent = `
      <html>
        <head>
          <title>Lista de Fiscales de Mesa</title>
          <style>
            body { font-family: Arial, sans-serif; margin: 20px; }
            h1 { color: #008945; text-align: center; }
            table { width: 100%; border-collapse: collapse; margin: 20px 0; }
            th, td { border: 1px solid #ddd; padding: 8px; text-align: left; }
            th { background-color: #008945; color: white; }
            tr:nth-child(even) { background-color: #f2f2f2; }
            .print-date { text-align: center; margin: 10px 0; }
          </style>
        </head>
        <body>
          <h1>Lista de Fiscales de Mesa</h1>
          <div class="print-date">Fecha de impresión: ${new Date().toLocaleDateString('es-ES')}</div>
          <table>
            <thead>
              <tr>
                ${tableHeaders.map(header => `<th>${header.name}</th>`).join('')}
              </tr>
            </thead>
            <tbody>
              ${filteredItems.map(item => `
                <tr>
                  <td>${item.provincia || ''}</td>
                  <td>${item.canton || ''}</td>
                  <td>${item.distrito || ''}</td>
                  <td>${item.jrv || ''}</td>
                  <td>${item.puesto || ''}</td>
                  <td>${item.cedula || ''}</td>
                  <td>${item.primerApellido || ''}</td>
                  <td>${item.segundoApellido || ''}</td>
                  <td>${item.nombre || ''}</td>
                </tr>
              `).join('')}
            </tbody>
          </table>
          <div class="print-date">Total de registros: ${filteredItems.length}</div>
        </body>
      </html>
    `;

    // Abrir ventana de impresión
    const printWindow = window.open('', '_blank', 'width=800,height=600');
    printWindow.document.write(printContent);
    printWindow.document.close();
    printWindow.focus();
    printWindow.print();
    printWindow.close();
  };

  return (
    <React.Fragment>
      <MacroList
        filters={<Filters config={listFilters()} />}
        dataEmpty={isDataEmpty}
        listName="Lista de Fiscales de Mesa"
        uiStylesClasses={classes}
        btnConfig={{
          name: '+ Agregar',
          event: () => history.push('/fiscales-mesa/add'),
          disabled: fiscalesMesaAvailable ? false : true,
        }}
        btnPrint={isDataEmpty ? null : {
          name: 'Imprimir',
          event: handlePrint,
        }}
        actionConfig={setActions}
        tableHeads={tableHeaders}
        tableBody={filteredItems}
        paginate={{
          show: false,
          page,
          totalPages: 10,
          onChangeHandler: pageHandler,
        }}
      />
      <PLNDialog
        open={open}
        onClose={() => {}}
        title="Eliminar Fiscal de Mesa"
        bodymessage={removedMsj}
        buttons={
          hiddenBtn
            ? []
            : [
                {
                  actionName: 'cancel',
                  color: 'simple',
                  title: 'Cerrar',
                  clickHander: () => {
                    setOpenDialog(!open);
                  },
                },
                {
                  actionName: 'delete',
                  disabled: isRemoved,
                  color: 'remove',
                  title: isRemoved ? (
                    <CircularProgress
                      style={{
                        width: '28px',
                        height: '24px',
                      }}
                    />
                  ) : (
                    'Eliminar'
                  ),
                  clickHander: removeMemberByNum,
                },
              ]
        }
      />
    </React.Fragment>
  );
};

export default FiscalesMesa;
